import { data, Link, useNavigate } from 'react-router-dom';
import './address-list.css'
import HeaderOther from './header-other';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

export default function AddressList() {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;
    const [address, setAddress] = useState(null);
    const [positionCoords, setPositionCoords] = useState([23.9925, 85.3637]);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const isLoggedIn = localStorage.getItem('userId') ? true : false

    useEffect(() => {

        if (isLoggedIn) {
            
            try {

                const dataToSend = {
                    userId: JSON.parse(localStorage.getItem('userId'))
                }
                fetch(`${BACKEND_URL}/get-user-address`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                        'content-type': 'application/json',
                    },
                    body:JSON.stringify(dataToSend)
                })
                    .then((response) => response.json())
                    .then((data) => {
                        console.log('address from server:', data)
                        if (data.address) {
                            setAddress(data.address)
                            setPositionCoords(data.positionCoords)
                        }
                        setLoading(false);
                }).catch((err) => alert('Something Went Wrong'))

            } catch (err) {
                console.log('error occured while fetching address: ', err);
                alert('Something went wrong!');
            } finally {
                setLoading(true)
            }
        }

    }, [])
    
    useEffect(() => {

        if (!isLoggedIn) { 
            const add = Cookies.get('address') === 'undefined' || Cookies.get('address') === undefined ? null : Cookies.get('address');
            setAddress(add)
            const positionCoords = Cookies.get('positionCoords') === 'undefined' || Cookies.get('positionCoords') === undefined ? null : Cookies.get('positionCoords');
            const coords = positionCoords ? String(positionCoords.split(',')) : [23.9925, 85.3637]
            setPositionCoords(coords)
        }

    }, [])
    
    let name = undefined
    let phone = undefined
    let fullAddress = undefined
    
    if (address !== null) {
        const add = address.split(',')
        name = add.shift()
        phone = add.pop()
        fullAddress = add
        console.log('address: ', address)
    }

    function handleSelect() {
        Cookies.remove('address', {path:'/'});
        Cookies.remove('positionCoords', {path:'/'});
        Cookies.set('address', address, { expires: 1, path: '/' });
        Cookies.set('positionCoords', positionCoords, { expires: 1, path: '/' })
        navigate(-1);
        console.log('handle select')
    }

    function handleDelete() {

        Cookies.remove('address')
        setAddress(null)
        console.log('handle Delete')
    }

    if (loading) {
        return (
            <>
                <HeaderOther />
                <div>
                    <p className='my-orders-heading' style={{borderBottom:'0.15px solid gray', margin:'10px'}}>Saved Address</p>
                    <div style={{display:'flex', flexDirection:'column' ,justifyContent:'center', alignItems:'center'}}>
                        <div className="spinner" style={{ borderLeftColor: '#2c5f2d', height: '30px', width: '30px' }}></div>
                        <p className='my-orders-heading' style={{color:'gray'}}>Fetching Address</p>
                    </div>
                </div>
            </>
        );
    }

    if (address === null) {
        return (
            <>
                <HeaderOther />
                <div>
                    <p className='my-orders-heading' style={{borderBottom:'0.15px solid gray', margin:'10px'}}>Saved Address</p>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <img src='/icons/map.png' alt='Address Not Found' style={{width:'200px', height:'200px'}}/>
                        <p className='my-orders-heading' style={{ color: 'gray' }}>No Address Found</p>
                        <Link to='/location-picker' className='add-new-address'>+ ADD ADDRESS</Link>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <HeaderOther />
            <div className='saved-address-header-section'>
                <p className='saved-address-heading'>Saved Address</p>
            </div>
            <div className='saved-address-container'>   
                <div className='saved-address-box'>
                    <div className='saved-address-first-half'>
                        <div className='saved-address-details'>
                            <p className='saved-address-home' style={{ fontWeight: 'bold', border:'0.15px solid #2c5f2d', borderRadius:'5px'}}>Home</p>
                        </div>
                        <div className='saved-address-btns'>
                            <Link to='/location-picker' state={{name:name, phone: phone, address: fullAddress, positionCoords: positionCoords}}><img src='/icons/pencil.png' alt='right-arrow' style={{height:'18px', width:'18px', marginRight:'10px'}}/></Link>
                            <img src='/delete.png' alt='right-arrow' onClick={handleDelete} style={{height:'18px', width:'18px', marginRight:'5px'}}/>
                        </div>
                    </div>
                    <div className='saved-address-second-half' onClick={handleSelect}>
                        <div className='saved-address-total'>
                            <p className='saved-address-text' style={{fontWeight:'bold', marginTop:'10px'}}>{name}</p>
                            <p className='saved-address-text' >{fullAddress}</p>
                            <p className='saved-address-text' >{phone}</p>
                        </div> 
                        <div><img src='/icons/right-arrow.png' alt='right-arrow' style={{height:'18px', width:'18px', marginRight:'5px'}}/></div>
                    </div>
                </div>
            </div>
        </>
    );
}